import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Clock } from "lucide-react";

const TrademinQuickContact = () => {
  const quickContact = [
    {
      icon: Phone,
      label: "Call Us",
      value: "+64 22 106 2796",
      href: "tel:+6422106796",
    },
    {
      icon: Mail,
      label: "Email Us",
      value: "Franco.stander@trademin.co.nz",
      href: "mailto:Franco.stander@trademin.co.nz",
    },
    {
      icon: Clock,
      label: "Working Hours",
      value: "Mon-Fri: 7AM - 6PM",
      href: null,
    },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500&display=swap');

        .qc-root {
          font-family: 'DM Sans', sans-serif;
          display: grid;
          grid-template-columns: 1fr 1fr;
          min-height: 100vh;
        }

        .qc-left {
          background: #111;
          padding: 8rem 7vw;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          overflow: hidden;
          border-right: 1px solid rgba(255,255,255,0.06);
        }

        .qc-watermark {
          position: absolute;
          bottom: -2rem;
          right: -1rem;
          font-family: 'DM Serif Display', serif;
          font-size: clamp(5rem, 12vw, 11rem);
          color: rgba(255,255,255,0.03);
          line-height: 1;
          user-select: none;
          pointer-events: none;
          white-space: nowrap;
        }

        .qc-glow {
          position: absolute;
          top: -20%;
          left: -20%;
          width: 70%;
          height: 70%;
          background: radial-gradient(circle, rgba(231,135,48,0.07) 0%, transparent 70%);
          pointer-events: none;
        }

        .qc-left-content { position: relative; z-index: 1; }

        .qc-eyebrow {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 2rem;
        }

        .qc-eyebrow-line {
          width: 28px;
          height: 1px;
          background: #E78730;
          flex-shrink: 0;
        }

        .qc-eyebrow-text {
          font-size: 0.68rem;
          letter-spacing: 0.26em;
          text-transform: uppercase;
          color: #E78730;
          font-weight: 500;
        }

        .qc-h2 {
          font-family: 'DM Serif Display', serif;
          font-size: clamp(2.5rem, 5vw, 4.5rem);
          line-height: 0.98;
          color: #fff;
          margin-bottom: 2rem;
          max-width: 14ch;
        }

        .qc-h2 em {
          color: #E78730;
          font-style: italic;
        }

        .qc-desc {
          font-size: 0.93rem;
          color: rgba(255,255,255,0.38);
          line-height: 1.85;
          max-width: 44ch;
          font-weight: 300;
          margin-bottom: 3.5rem;
        }

        .qc-actions {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .qc-btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 0.6rem;
          background: #E78730;
          color: #fff;
          font-size: 0.7rem;
          font-weight: 500;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          text-decoration: none;
          padding: 1rem 2.25rem;
          font-family: 'DM Sans', sans-serif;
          transition: opacity 0.2s;
          line-height: 1;
        }
        .qc-btn-primary:hover { opacity: 0.82; }
        .qc-btn-primary svg { transition: transform 0.25s; }
        .qc-btn-primary:hover svg { transform: translateX(3px); }

        .qc-btn-ghost {
          display: inline-flex;
          align-items: center;
          gap: 0.6rem;
          border: 1px solid rgba(255,255,255,0.15);
          color: rgba(255,255,255,0.55);
          font-size: 0.7rem;
          font-weight: 400;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          text-decoration: none;
          padding: 1rem 2.25rem;
          font-family: 'DM Sans', sans-serif;
          transition: border-color 0.25s, color 0.25s;
          line-height: 1;
        }
        .qc-btn-ghost:hover {
          border-color: rgba(255,255,255,0.4);
          color: #fff;
        }

        .qc-right {
          background: #fafaf8;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .qc-img-strip {
          width: 100%;
          height: 280px;
          background: #ede9e3;
          overflow: hidden;
          flex-shrink: 0;
          border-bottom: 1px solid #e8e8e4;
        }

        .qc-img-strip img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          filter: grayscale(20%);
        }

        .qc-img-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          gap: 0.75rem;
          color: #c0b9b0;
        }

        .qc-img-placeholder span {
          font-size: 0.62rem;
          letter-spacing: 0.2em;
          text-transform: uppercase;
        }

        .qc-contacts {
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .qc-contact-item {
          display: flex;
          align-items: center;
          gap: 2rem;
          padding: 2.25rem 4rem;
          border-bottom: 1px solid #e8e8e4;
          text-decoration: none;
          transition: background 0.2s;
          cursor: default;
        }

        a.qc-contact-item { cursor: pointer; }
        a.qc-contact-item:hover { background: #f4f1ec; }

        .qc-contact-item:last-child { border-bottom: none; }

        .qc-contact-icon {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: #E78730;
        }

        .qc-contact-divider {
          width: 1px;
          height: 36px;
          background: #e8e8e4;
          flex-shrink: 0;
        }

        .qc-contact-label {
          font-size: 0.65rem;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #bbb;
          font-weight: 500;
          margin-bottom: 0.3rem;
        }

        .qc-contact-value {
          font-size: 1rem;
          color: #1a1a1a;
          font-weight: 400;
        }

        @media (max-width: 900px) {
          .qc-root { grid-template-columns: 1fr; min-height: unset; }
          .qc-left { padding: 6rem 7vw; }
          .qc-contact-item { padding: 2rem 7vw; }
          .qc-img-strip { height: 220px; }
        }
      `}</style>

      <section className="qc-root">
        {/* Left dark pane */}
        <div className="qc-left">
          <div className="qc-glow" />
          <div className="qc-watermark">PROJECT</div>
          <div className="qc-left-content">
            <div className="qc-eyebrow">
              <span className="qc-eyebrow-line" />
              <span className="qc-eyebrow-text">Get In Touch</span>
            </div>
            <h2 className="qc-h2">
              Let's Discuss Your <em>Project</em>
            </h2>
            <p className="qc-desc">
              Have a project in mind or need reliable electrical and mechanical
              services? Our expert team delivers professional, high-quality
              solutions tailored to your specific needs.
            </p>
            <div className="qc-actions">
              <Link to="/contact-us" className="qc-btn-primary">
                Contact Us Today
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </Link>
              <Link to="/request-quote" className="qc-btn-ghost">
                Request a Quote
              </Link>
            </div>
          </div>
        </div>

        {/* Right light pane */}
        <div className="qc-right">
          <div className="qc-img-strip">
            <div className="qc-img-placeholder">
              <svg
                width="36"
                height="36"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
              >
                <rect x="3" y="3" width="18" height="18" rx="1" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
              </svg>
              <span>Image placeholder</span>
            </div>
          </div>

          <div className="qc-contacts">
            {quickContact.map((contact, index) => {
              const Icon = contact.icon;
              if (contact.href) {
                return (
                  <a
                    key={index}
                    href={contact.href}
                    className="qc-contact-item"
                  >
                    <div className="qc-contact-icon">
                      <Icon size={18} strokeWidth={1.5} />
                    </div>
                    <div className="qc-contact-divider" />
                    <div>
                      <div className="qc-contact-label">{contact.label}</div>
                      <div className="qc-contact-value">{contact.value}</div>
                    </div>
                  </a>
                );
              }
              return (
                <div key={index} className="qc-contact-item">
                  <div className="qc-contact-icon">
                    <Icon size={18} strokeWidth={1.5} />
                  </div>
                  <div className="qc-contact-divider" />
                  <div>
                    <div className="qc-contact-label">{contact.label}</div>
                    <div className="qc-contact-value">{contact.value}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default TrademinQuickContact;
